import React from "react"

import {EnumFilterContent} from "../../../../components/EnumFilter.tsx"
import {enumToOptions} from "../../../../utils/i18n.tsx"
import {SalesAssistantDealsFilteringContext, TPlannedActivitiesOption, TPrioritiesOption} from "../../hooks.ts"

const priorityOptions = enumToOptions("SalesAssistantDealPriority") as TPrioritiesOption[]
export const PriorityFilter: React.FC = () => {
  const {priorityFilter, setPriorityFilter} = SalesAssistantDealsFilteringContext.useContext()

  return <EnumFilterContent options={priorityOptions} multiple value={priorityFilter} onChange={setPriorityFilter} />
}

const plannedActivityOptions = enumToOptions("SalesAssistantPlannedActivity") as TPlannedActivitiesOption[]
export const PlannedActivityFilter: React.FC = () => {
  const {plannedActivityFilter, setPlannedActivityFilter} = SalesAssistantDealsFilteringContext.useContext()

  return (
    <EnumFilterContent
      options={plannedActivityOptions}
      multiple
      value={plannedActivityFilter}
      onChange={setPlannedActivityFilter}
    />
  )
}
